module.exports = __webpack_public_path__ + "img/how-it-works-header.79c8bb38.jpg";